import { Interpreter } from "./interpreter/main";
import * as vm from "./vm";
import evaluate from "./evaluate";
import Function from "./Function";
export { Interpreter, vm, evaluate, Function };
export default evaluate;
